import Clickable from 'components/Common/Clickable'
import useMerchandiseBrand from 'hooks/Merchandise/useMerchandiseBrand'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import Sheet from 'components/utils/Sheet'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getMerchandiseBrandSearchUrl } from '../merchandiseUtils'

const Container = styled(Sheet)`
  width: ${rem(170)};
  height: ${rem(104)};

  ${mediaQueryUp.desktop} {
    width: unset;
    height: ${rem(104)};
  }

  &:hover {
    box-shadow: inset 0px 0px 0px 1px ${props => props.theme.palette.neutral.default.one};
  }
`

interface Props {
  id: string
}

function MerchandiseBrandCard(props: Props) {
  const { id } = props

  const [brand] = useMerchandiseBrand(id)

  if (!brand) {
    return <LoadingBox
      width={180}
      height={104}
    />
  }

  return <Clickable
    key={brand.id}
    to={getMerchandiseBrandSearchUrl(brand)}
  >
    <Container
      border="neutral-five"
      borderRadius="M"
      background="neutral-eight"
      padding={8}
    >
      {brand.logo && <Image
        fit="center"
        image={brand.logo}
        objectFit="contain"
        width={180}
      />}
    </Container>
  </Clickable>
}

export default MerchandiseBrandCard
